import { Pagination, PaginationProps } from 'react-admin';

const MyPagination = (props: PaginationProps) => {
	return <Pagination rowsPerPageOptions={[10, 50, 100, 200, 300, 400]} {...props} />;
};
export default MyPagination;
